import React from "react";
import LoadingButton from "./LoadingButton";
import "./RawDataUploadSection.css";

const RawDataUploadSection = ({
  fileRef,
  selectedFile,
  handleFileChange,
  uploadOptions,
  setUploadOptions,
  uploadRawData,
  loading,
  bcomeVersionMap,
  selectedBcomeVersionId,
  setSelectedBcomeVersionId
}) => {
  const versionOptions = Object.entries(bcomeVersionMap || {});
  const uploadDisabled = !selectedBcomeVersionId;

  return (
    <>
      <div className="raw-data-upload-section__divider"></div>

      <div className="raw-data-upload-section">
        <h3 className="raw-data-upload-section__title">Raw data upload</h3>
        <div className="raw-data-upload-section__upload-area">
          <input
            type="file"
            ref={fileRef}
            onChange={handleFileChange}
            className="raw-data-upload-section__file-input"
          />
          {selectedFile && (
            <div className="raw-data-upload-section__file-preview">
              <img src="/preview-xlsx.png" alt="Excel file" />
              <div className="raw-data-upload-section__file-name">
                {selectedFile.name}
              </div>
            </div>
          )}
        </div>

        <div className="raw-data-upload-section__controls">
          <div className="raw-data-upload-section__checkboxes">
            <label className="raw-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.traceability}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  traceability: e.target.checked
                })}
              />
              Traceability
            </label>
            <label className="raw-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.ecomReferences}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  ecomReferences: e.target.checked
                })}
              />
              Ecom references
            </label>
            <label className="raw-data-upload-section__checkbox-label">
              <input
                type="checkbox"
                checked={uploadOptions.qrCodes}
                onChange={(e) => setUploadOptions({
                  ...uploadOptions,
                  qrCodes: e.target.checked
                })}
              />
              QR codes and images only
            </label>
          </div>
          <div className="raw-data-upload-section__upload-controls">
            <div className="raw-data-upload-section__version-field">
              <label
                htmlFor="raw-data-upload-version-set"
                className="raw-data-upload-section__version-label"
              >
                Version Set
              </label>
              <select
                id="raw-data-upload-version-set"
                className="raw-data-upload-section__version-select"
                value={selectedBcomeVersionId || ""}
                onChange={(e) => setSelectedBcomeVersionId(e.target.value)}
              >
                <option value="" disabled>
                  Select Version Set
                </option>
                {versionOptions.map(([id, label]) => (
                  <option key={id} value={id}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            <LoadingButton
              color="primary"
              variant="contained"
              className="raw-data-upload-section__upload-button"
              onClick={uploadRawData}
              loading={loading}
              disabled={uploadDisabled}
            >
              Upload
            </LoadingButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default RawDataUploadSection;
